<template>
  <v-card outlined :loading="loading">
    <template slot="progress">
      <v-progress-linear color="primary" indeterminate></v-progress-linear>
    </template>
    <v-toolbar dense color="primary lighten-1" dark flat v-if="!hiddenToolbar">
      <v-icon>{{ titleIcon }}</v-icon>
      <v-toolbar-title class="ml-1">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="toolbar-append">
        <rx-btn
          v-if="editable && editableRoles.add"
          color="success"
          @click.stop="addNewItem"
        >
          <v-icon class="text-md-right text-sm-center">$btn_add</v-icon>
          {{ (this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name =='xs') ? null : $t("common.btn.add_new") }}
        </rx-btn>
      </slot>
      <!-- 정렬 버튼 표시 영역 END -->
      <!-- <v-scale-transition>
        <span v-if="editable && sortable">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-1 elevation-2"
                fab
                x-small
                color="secondary"
                v-on="on"
                @click="moveMenu('U')"
              >
                <v-icon>arrow_drop_up</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("common.btn.up") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-1 elevation-2"
                fab
                x-small
                color="secondary"
                v-on="on"
                @click="moveMenu('D')"
              >
                <v-icon>arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("common.btn.down") }}</span>
          </v-tooltip>
        </span>
      </v-scale-transition> -->
      <!-- 정렬 버튼 표시 영역 END -->
    </v-toolbar>
    <!-- 검색 바 및 기타 활용 영역 START -->
    <v-sheet color="primary lighten-1">
      <v-row>
        <v-col class="mx-4">
          <v-text-field
            background-color="primary lighten-5"
            v-model="search"
            autocomplete="off"
            :label="$t('common.lbl.search')"
            flat
            solo
            hide-details
            clearable
            dense
            clear-icon="$vuetify.icons.fld_clear"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-sheet>
    <!-- 검색 바 및 기타 활용 영역 END -->
    <!-- 트리 표시 영역 START -->
    <v-card class="overflow-y-auto" :max-height="scrollHeight" flat>
      <v-treeview
        v-bind="$attrs"
        v-on="$listeners"
        :active.sync="innerActive"
        :open.sync="open"
        :items="items"
        :activatable="activatable"
        open-all
        :selectable="selectable"
        :open-on-click="openOnclick"
        :hoverable="hoverable"
        transition
        :search="search"
      >
        <!-- wrapping 콤포넌트의 모든 템플릿을 상속 받기 -->
        <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
          <slot :name="slot" v-bind="scope" />
        </template>
        <template #append="{ item, active }">
          <slot name="append" :item="item" :active="active">
            <span v-if="editable && active">
              <rx-btn
                v-if="editableRoles.addChild"
                x-small
                fab
                color="success"
                dark
                class="px-1"
                elevation="3"
                @click.stop="addChildItem(item)"
              >
                <v-icon>$btn_add</v-icon>
              </rx-btn>
              <rx-btn
                v-if="editableRoles.edit"
                x-small
                fab
                color="warning"
                dark
                class="px-1"
                elevation="3"
                @click.stop="editItem(item)"
              >
                <v-icon>$btn_edit</v-icon>
              </rx-btn>
              <rx-btn
                v-if="
                  editableRoles.remove &&
                  (rootExpected === undefined || item.parentId !== rootExpected)
                "
                x-small
                fab
                color="error"
                dark
                class="px-1"
                elevation="3"
                @click.stop="removeItem(item)"
              >
                <v-icon>$btn_remove</v-icon>
              </rx-btn>
            </span>
          </slot>
        </template>
      </v-treeview>
    </v-card>
    <!-- 트리 표시 영역 END -->
  </v-card>
</template>

<script>
export default {
  components: {},
  props: {
    // hiddenIcon: Boolean,
    dataSet: Array,
    scrollHeight: [String, Number],
    editable: Boolean,
    sortable: Boolean,
    editableRoles: {
      type: Object,
      default: () => ({
        add: true,
        edit: true,
        remove: true,
      }),
    },
    title: String,
    titleIcon: { type: String, default: "list_alt" },
    selectable: Boolean,
    hoverable: {
      type: Boolean,
      default: true,
    },
    activatable: {
      type: Boolean,
      default: true,
    },
    openOnclick: Boolean,
    hiddenToolbar: Boolean,
    rootItemField: String, //upperId 상위코드필드명
    rootExpected: String, // 예상 값
    itemIdField: String,
    itemLabelField: String,
    loading: Boolean,
    active: Array,
    // height: [String, Number]
    openRoot: Boolean,
  },
  computed: {
    breakpoint() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return true;
        default:
          return true;
      }
    }
  },
  data() {
    return {
      items: [], //트리 아이템
      search: "",
      caseSensitive: false,
      open: [],
      innerActive: this.active,
    };
  },
  methods: {
    getChildren(item, isParent) {
      let target = [];
      if (isParent) {
        target = this.dataSet.filter((i) => {
          return i[this.rootItemField] == this.rootExpected;
        });
      } else {
        target = this.dataSet.filter((i) => {
          return i[this.rootItemField] == item[this.itemIdField];
        });
      }
      let nodeSet = [];
      target.forEach((i) => {
        let itemSet = {
          id: i[this.itemIdField],
          label: i[this.itemLabelField],
          icon: i[this.itemIconField],
          name: i[this.itemLabelField],
          parentId: i[this.rootItemField],
          content: i,
          children: this.getChildren(i),
        };
        nodeSet.push(itemSet);
      });
      //아이템 ASC 정렬
      // nodeSet.sort(function (a, b) {
      //   var nameA = a.label.toUpperCase();
      //   var nameB = b.label.toUpperCase();
      //   if (nameA < nameB) {
      //     return -1;
      //   }
      //   if (nameA > nameB) {
      //     return 1;
      //   }
      //   return 0;
      // });
      return nodeSet;
    },
    makeItems() {
      if (this.dataSet.length > 0) {
        const result = this.getChildren(null, true);
        this.items = result;
        if(this.openRoot) {
          //초기 1레벨 펼침
          this.open.push(result[0].id);
        }
      }
    },
    addNewItem() {
      this.$emit("addItem", this.items[0].id);
    },
    addChildItem(item) {
      this.$emit("addItem", item.id);
    },
    editItem(item) {
      this.$emit("editItem", item.content);
    },
    async removeItem(item) {
      if (
        await this.$rxConfirm(
          "error",
          this.$t("common.lbl.delete"),
          this.$t("common.msg.delete_confirm")
        )
      ) {
        this.$emit("removeItem", item.content);
      }
    },
  },
  watch: {
    dataSet() {
      this.makeItems();
    },
    active() {
      this.innerActive = this.active;
    },
    innerActive(v) {
      this.$emit("update:selected",v);
    }
  },
  created() {
    this.makeItems();
  },
};
</script>